var render = function render(){var _vm=this,_c=_vm._self._c;return _c('OrderDetails',{attrs:{"orderId":_vm.orderId}})
}
var staticRenderFns = []

export { render, staticRenderFns }